import { styled } from '@mui/material/styles';

export const StyledFileButton = styled('div')({
  fontWeight: 600,
  backgroundColor: '#E9BC46',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 12px',
  borderRadius: '4px',
  '& a': {
    color: '#38414f',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});
